// extracted by mini-css-extract-plugin
export default {"pages":"Paginiation_pages__CWHwV","page--item":"Paginiation_page--item__KUBRt","page--link":"Paginiation_page--link__jw+I8","active":"Paginiation_active__LljRO"};